import React from 'react';
import { CompanyOptionStyle } from './style';

export default function CompanyOption({ comp }) {
  return (
    <CompanyOptionStyle isBlocked={comp.isActive}>
      <p>
        {comp.name}
        {!comp.isActive && ' (Inativo)'}
      </p>
      <a href={`/editar-empresa/${comp._id}`}>Editar</a>
    </CompanyOptionStyle>
  );
}
